export default __webpack_public_path__ + "static/media/SolutionDeveloppeur.03dbefed.webp";